<template>
  <Breadcrumbs
      title="Trust History List"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Trust Management', path: '/trust-history' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <trustHistoryListTable/>
    </div>
  </div>
</template>

<script>

import trustHistoryListTable from "@/pages/master_data/trust_management/trustHistoryTable.vue";

export default {
  components: {
    trustHistoryListTable
  }
}

</script>